import { useTranslation } from 'react-i18next'
import { Checkbox, Col, Row } from 'antd'

import { USER_STATUS_ARRAY } from '@/libs/constants/user'

interface UserStatusCheckboxProps {
  value?: string[]
  onChange?: (checkedValues: string[]) => void
  isDisabled?: boolean
}

const UserStatusCheckbox = ({
  value,
  onChange,
  isDisabled,
}: UserStatusCheckboxProps) => {
  const { t } = useTranslation()

  const renderStatusLabel = (labelValue) => {
    return t(
      `adminWorkspace.userManagement.userDetails.userStatus.${labelValue}`,
    )
  }

  return (
    <Checkbox.Group disabled={isDisabled} value={value}>
      <Row gutter={[12, 12]}>
        {USER_STATUS_ARRAY.map((userStatus) => (
          <Col key={userStatus.value}>
            <Checkbox
              value={userStatus.value}
              onChange={() => onChange?.([userStatus.value])}
            >
              {renderStatusLabel(userStatus.label)}
            </Checkbox>
          </Col>
        ))}
      </Row>
    </Checkbox.Group>
  )
}

export default UserStatusCheckbox
